<template>
  <hypto-popup :title="'Export Details'" :footer="hasRecords">
    <template v-slot:body>
      <p v-if="!hasRecords">No {{pluralize(exportOptions.type || 'transaction', 0)}} found. Please try changing filters.</p>
      <p v-else-if="exportOptions.total">Are you sure you want to export <b>{{exportOptions.total}}</b> {{pluralize(exportOptions.type || 'transaction', exportOptions.total)}}?</p>
      <p v-else>Are you sure you want to export these transactions?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="exportRecords">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import { pluralize } from '@/utils/helpers'

export default {
  name: 'ExportConfirmation',
  components: { HyptoPopup },
  props: {
    exportOptions: Object,
    exportRecords: Function
  },
  computed: {
    hasRecords () {
      // eslint-disable-next-line
      return this.exportOptions.total || this.exportOptions.next_page_token ? true : false
    }
  },
  methods: {
    pluralize
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
  }

  .mobile {
    p {
      text-align: left;
    }
  }
</style>
